<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>
        <template #main>
            <main-header title="Certificates, Forms & Reports" icon="fa-file-certificate"/>

            <b-message type="is-warning" class="mt-6" v-if="currentUser">
                <div class="columns is-gapless mt-4">
                    <div class="column is-narrow"><i class="fas fa-question-circle fa-fw mr-3 has-text-warning"></i></div>
                    <div class="column">
                        <div class="is-size-6 has-text-weight-bold">Looking for your Course Completion Forms?</div>

                        <div class="is-size-6 mt-3">We are upgrading the my247ed.com site. If you’re looking for your course enrollments and completion records, please visit the legacy site button below to access your courses as usual. If you have any questions feel free to contact us at <a href="mailto:support@my247ed.com">support@my247ed.com</a>.</div>
                        <div class="mb-4 mt-5">
                            <b-button tag="a" type="is-primary" :href="'https://www.my247ed.com/account/doAppLogin.php?u=' + currentUser.email + '&h=' + currentUser.legacy_hash">Visit Legacy Site<i class="fad fa-arrow-up-right-from-square ml-3"></i></b-button>
                        </div>
                    </div>
                </div>
            </b-message>

            <div class="columns mt-6">
                <div class="column is-8 is-12-tablet">

                    <div class="mb-6 pb-4 content">
                        <h5 class="has-text-white">Certification/Organization:</h5>
                        <b-select v-model="cert" class="mt-2">
                            <option value="ospi">Washington State Professional Development</option>
                            <option value="wiaa">Washington Interscholastic Activities Association (WIAA)</option>
                        </b-select>
                    </div>

                    <div v-if="cert==='ospi'">
                        <h2><i class="fad fa-file-certificate fa-fw mr-3"></i>Official Completion Forms</h2>

                        <p class="has-text-white mt-5"><i class="far fa-info-circle fa-fw mr-4 ml-5 pl-3"></i>You currently have no course enrollments that are complete or qualify for this certification.</p>

                        <h2 class="mt-6 pt-4"><i class="fad fa-file-pdf fa-fw mr-2"></i>Other or Internal Forms</h2>
                        <p class="has-text-white mt-5"><i class="far fa-info-circle fa-fw mr-4 ml-5 pl-3"></i>You currently have no course enrollments that are complete or qualify for this certification.</p>

                        <h2 class="mt-6 pt-4"><i class="fad fa-file-invoice fa-fw mr-2"></i>Receipts & Invoices</h2>
                        <p class="has-text-white mt-5"><i class="far fa-info-circle fa-fw mr-4 ml-5 pl-3"></i>You currently have no receipts or invoices.</p>
                    </div>

                    <div v-if="cert==='wiaa'">
                        <div class=" content">
                            <div class="columns">
                                <div class="column is-narrow">
                                    <i class="fad fa-info-circle has-text-white fa-2x"></i>
                                </div>
                                <div class="column has-text-white">
                                    <div class="mb-5 is-size-4">Washington Interscholastic Activities Association (WIAA)</div>
                                    <div class="mb-6"><span class="has-text-weight-bold">Washington Interscholastic Activities Association (WIAA)</span> certifications are managed by <span class="has-text-weight-bold">FinalForms</span>. To update your certification status in FinalForms, log in to FinalForms and click 'Sync Certifications with my247ed' in your profile. If your certifications are not syncing properly please check your
                                        <router-link to="account" class="has-text-white has-text-underline">integration settings</router-link>
                                        and your WIAA Membership ID.
                                    </div>
                                    <a href="https://wiaa.finalforms.com/athletic_association_staff/find_district" target="_blank">
                                        <b-button type="is-light" outlined>View Certification Status at <span class="has-text-weight-bold">FinalForms</span><i class="far fa-up-right-from-square ml-3"></i></b-button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>
    </framework>
</template>

<script>
    import Framework from "../../components/framework/Framework";
    import MainHeader from "../../components/framework/MainHeader";
    import SidePanelNav from "../../components/framework/SidePanelNav";
    import {mapGetters} from "vuex";

    export default {
        components: {Framework, SidePanelNav, MainHeader},
        data: function() {
            return {
                cert: 'ospi'
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 1.2rem;
        color: white;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        i {
            color: white;
        }
    }

    .has-text-underline {
        text-decoration: underline;
    }
</style>
